import { LoginCard, BrandLogo, useAppMessage } from "@repo/ui";
import { useLogin } from "@src/queries";
import { useNavigate, useSearchParams } from "react-router";
import { ACCESS_STORAGE_KEY } from "@src/config";

export default function LoginPage() {
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const redirect = params.get("redirect") ?? "/";

    const notify = useAppMessage();

    const { mutateAsync, isPending } = useLogin({
        onSuccess: (data) => {
            localStorage.setItem(ACCESS_STORAGE_KEY, data.access_token);
            notify.success("С возвращением!");
            navigate(redirect, { replace: true });
        },
        onError: (err) => {
            notify.apiError(err ?? "Ошибка входа");
        },
    });

    async function handleSubmit(values: { email: string; password: string }) {
        await mutateAsync({ username: values.email, password: values.password });
    }

    return (
        <div
            style={{
                minHeight: "100vh",
                display: "grid",
                placeItems: "center",
                padding: 24,
            }}
        >
            <LoginCard
                logo={<BrandLogo src="/icon.svg" text="Optim S" height={40} />}
                onSubmit={handleSubmit}
                loading={isPending}
                signUpHref="/register"
                forgotHref="/forgot-password"
            />
        </div>
    );
}
